document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper not loaded');
    return;
  }

  const MOBILE_BREAKPOINT = 768;
  const tabSections = document.querySelectorAll('.prod_tab_main');
  if (!tabSections.length) return;

  tabSections.forEach(function (section) {
    const tabItems = Array.from(section.querySelectorAll('.prod_tab_cont_tab_item'));
    const tabButtons = tabItems
      .map((t) => t.querySelector('.prod_tab_cont_tab_btn'))
      .filter(Boolean);

    const panels = Array.from(section.querySelectorAll('.prod_tab_pannle'));
    if (!tabItems.length || !panels.length) return;

    function setupPanel(panel) {
      const swiperEl = panel.querySelector('.prod_card_slider_swiper');
      if (!swiperEl) return;

      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        destroySwiper(swiperEl);
      } else {
        initDesktopSwiper(panel, swiperEl);
      }
    }

    panels.forEach(function (panel) {
      setupPanel(panel);
    });

    tabItems.forEach(function (tabItem) {
      const btn = tabItem.querySelector('.prod_tab_cont_tab_btn');
      if (!btn) return;

      tabItem.addEventListener('click', function () {
        tabItems.forEach((t) => t.classList.remove('active'));
        tabButtons.forEach((b) => b.setAttribute('aria-selected', 'false'));

        panels.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        });

        tabItem.classList.add('active');
        btn.setAttribute('aria-selected', 'true');

        const panelId = btn.getAttribute('aria-controls');
        const activePanel = panelId ? section.querySelector('#' + CSS.escape(panelId)) : null;
        if (!activePanel) return;

        activePanel.removeAttribute('hidden');
        activePanel.classList.add('is-active');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setupPanel(activePanel);
          });
        });
      });
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        panels.forEach(function (panel) {
          setupPanel(panel);
        });
      }, 150);
    });
  });

  function initDesktopSwiper(panel, swiperEl) {
    if (swiperEl.swiper) {
      swiperEl.swiper.updateSize();
      swiperEl.swiper.updateSlides();
      swiperEl.swiper.updateProgress();
      swiperEl.swiper.update();
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 20,
      slidesPerGroup: 3,
      grid: {
        rows: 2,
        fill: 'row'
      },
      navigation: {
        nextEl: panel.querySelector('.prod_card_slider_swiper_button_next'),
        prevEl: panel.querySelector('.prod_card_slider_swiper_button_prev'),
      },
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      roundLengths: true
    });
  }

  function destroySwiper(swiperEl) {
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  }
});